/* eslint-disable jsx-a11y/anchor-is-valid */
import { Facebook, Instagram, Linkedin, Twitter, Youtube } from "lucide-react";
import { SpotifyIcon } from "../svg/spotify";

export default function Footer({onOpen}: { onOpen: () => void }) {
  return (
    <footer className="w-full bg-[#f8f8f8] border-t md:mt-2 mt-0 text-sm text-gray-700">
      <div className="max-w-6xl mx-auto px-4 py-10 flex flex-col md:flex-row justify-between">
        {/* Logo + Social */}
        <div className="flex flex-col items-center md:items-start justify-between gap-4">
          <img
            src=" https://sitecoreaudioprod.umusicpub.com/sitecore_media/25C013D5-FDEE-4AF4-98DB-E1F8465DE477.png"
            alt="UMPG Logo"
            className="h-[45px]"
          />
          <div className="flex gap-2" onClick={onOpen}>
            <CircleIcon icon={<Twitter size={14} />} />
            <CircleIcon icon={<Instagram size={14} />} />
            <CircleIcon icon={<Facebook size={14} />} />
            <CircleIcon icon={<SpotifyIcon />} />
            <CircleIcon icon={<Youtube size={14} />} />
            <CircleIcon icon={<Linkedin size={14} />} />
          </div>
        </div>

        {/* Link Column 1 */}
        <div className=" grid grid-cols-2 gap-12 mt-8 md:mt-0">
          <div className="flex flex-col gap-2  text-black" onClick={onOpen}>
            <a >Privacy Policy</a>
            <a >Terms & Conditions</a>
            <a >Do not sell my personal information</a>
            <a >Song List</a>
            <a >Royalty Inquiries</a>
          </div>

          {/* Link Column 2 */}
          <div className="flex flex-col gap-2" onClick={onOpen}>
            <a >License Request</a>
            <a >UMPG Window</a>
            <a >Universal Production Music</a>
            <a >Elias Audio Branding</a>
            <a >Cookie Choices</a>
          </div>
        </div>
      </div>

      <div className="max-w-6xl  mx-auto mt-12 border-t pt-6 text-sm text-gray-500" onClick={onOpen}>
        <div className="flex justify-between items-center w-full px-4 md:px-0">
          <p>© 2025 Universal Music Publishing Group</p>
          <div className="space-x-4 md:display hidden">
            <a >Privacy</a>
            <a >Terms</a>
            <a >Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

function CircleIcon({ icon }: { icon: React.ReactNode }) {
  return (
    <div className="w-7 h-7 rounded-full border border-gray-300 flex items-center justify-center text-gray-600 hover:bg-gray-200 cursor-pointer">
      {icon}
    </div>
  );
}
